import React from 'react';

const Heart = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 28 24" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path
        id="Heart_a"
        d="M274.72 276.45h-5.94a.68.68 0 0 1-.53-.27l-1.97-2.79-2.5 5.24a.65.65 0 0 1-.58.36l-.01.01a.66.66 0 0 1-.58-.35l-1.71-3.35-.51.82a.63.63 0 0 1-.56.33h-4.93a.65.65 0 0 1-.65-.63c0-.36.3-.65.65-.65h4.55l.93-1.53c.13-.19.35-.3.59-.3.23 0 .45.14.55.35l1.62 3.23 2.42-5.05c.1-.2.3-.34.53-.37.23 0 .46.09.6.28l2.43 3.39h5.6c.36 0 .66.3.66.65 0 .35-.3.63-.66.63"
      />
      <path
        id="Heart_b"
        d="M264.82 290.25c-.4 0-.75-.14-1.02-.38l-10.26-9.39a7.48 7.48 0 0 1 0-11.23 8.72 8.72 0 0 1 6.21-2.2c1.83.06 3.6.64 5.06 1.64a9.62 9.62 0 0 1 5.07-1.65 8.76 8.76 0 0 1 6.2 2.2 7.48 7.48 0 0 1 0 11.24l-10.25 9.38a1.5 1.5 0 0 1-1.01.4zm-5.44-21.78c-1.77 0-3.48.64-4.73 1.79a6.14 6.14 0 0 0 0 9.21l10.16 9.3 10.17-9.3a6.14 6.14 0 0 0 0-9.22 7.09 7.09 0 0 0-5.04-1.78 7.9 7.9 0 0 0-4.62 1.67l-.51.41-.51-.4a7.9 7.9 0 0 0-4.92-1.68z"
      />
    </defs>
    <use fill="currentColor" xlinkHref="#Heart_a" transform="translate(-251 -267)" />
    <use fill="currentColor" xlinkHref="#Heart_b" transform="translate(-251 -267)" />
  </svg>
);

export default Heart;



// WEBPACK FOOTER //
// ./src/common/icons/Heart.js